import { AppProvider } from 'context';
import { AppRoutes } from 'routes';

export const App = () => {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
};
